// extracted by mini-css-extract-plugin
export default {"badgeCustom":"BoxSuperuser_badgeCustom__KVpLz"};